import { render } from "./Research.vue?vue&type=template&id=251bf11a&scoped=true"
import script from "./Research.vue?vue&type=script&lang=js"
export * from "./Research.vue?vue&type=script&lang=js"

import "./Research.vue?vue&type=style&index=0&id=251bf11a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-251bf11a"]])

export default __exports__